<template>
	<v-container>
		<v-card
			class="mx-auto"
			tile
			@click="$inertia.visit($route('shop.index'))"
		>
			<v-list subheader two-line color="secondary" dark>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title
							class="text-uppercase font-weight-bold"
							>Place an order</v-list-item-title
						>

						<v-list-item-subtitle
							>Order Food & Drinks for delivery, pick-up <br />
							or dine-in.</v-list-item-subtitle
						>
					</v-list-item-content>
					<v-list-item-action>
						<v-icon size="100">mdi-clipboard-text-outline</v-icon>
					</v-list-item-action>
				</v-list-item>
			</v-list>
		</v-card>
	</v-container>
</template>
<script>
export default {
	props: ["socials"],
	data() {
		return {
			items: [
				{
					icon: "mdi-facebook",
					link: this.socials.facebook,
				},
				{
					icon: "mdi-twitter",
					link: this.socials.twitter,
				},
				{
					icon: "mdi-linkedin",
					link: this.socials.linkedin,
				},
				{
					icon: "mdi-instagram",
					link: this.socials.instagram,
				},
			],
		};
	},
};
</script>